import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './App.css';

import 'react-toastify/dist/ReactToastify.css';
import RouterApp from './router';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { IconButton, Snackbar, SnackbarContent, Typography } from '@mui/material';
import { MdCheck, MdClose, MdError, MdOutlineWarning, MdWarning } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { errorMessage, successMessage } from './logic/error/action';
import { TenantProvider } from './context/TenantContext';


function App() {
  const dispatch = useDispatch();
  const selector = useSelector(state=>state.error);
  return (
   <BrowserRouter>
   <LocalizationProvider dateAdapter={AdapterDayjs}>
   <TenantProvider>
   {/* <ToastContainer/> */}
   <Snackbar 
  //  title='Error'
  //  content='Hello'
  color='white'
  anchorOrigin={{vertical:'bottom',horizontal:'right'}}
  open={selector.errorState !== ''}
  // open={true}
  autoHideDuration={3000}
  onClose={()=>{
    errorMessage(dispatch,'');
  }}
  >
    <SnackbarContent 
     sx={{bgcolor:'#fff',color:'red'}}
     action={<IconButton onClick={()=>{errorMessage(dispatch,'')}}><MdClose color='red'/></IconButton>}
    message={
      <span className='flex items-center gap-1'>
        <MdOutlineWarning color='red' fontSize={'1.2rem'}/>
        <Typography variant='inherit'>{selector.errorState}</Typography>
      </span>
    }
    />
   </Snackbar>
   <Snackbar 
  //  title='Error'
  //  content='Hello'
  color='white'
  anchorOrigin={{vertical:'bottom',horizontal:'right'}}
  open={selector.successState !== ''}
  // open={true}
  autoHideDuration={3000}
  onClose={()=>{
    successMessage(dispatch,'');
  }}
  >
    <SnackbarContent 
     sx={{bgcolor:'#fff',color:'green'}}
     action={<IconButton onClick={()=>{successMessage(dispatch,'')}}><MdClose color='green'/></IconButton>}
    message={
      <span className='flex items-center gap-1'>
        <MdCheck color='green' fontSize={'1.2rem'}/>
        <Typography variant='inherit'>{selector.successState}</Typography>
      </span>
    }
    />
   </Snackbar>
   <RouterApp/>
   </TenantProvider>
   </LocalizationProvider>
   </BrowserRouter>
  );
}

export default App;
